import { render, staticRenderFns } from "./platformCard.vue?vue&type=template&id=7aecd055&scoped=true&"
import script from "./platformCard.vue?vue&type=script&lang=js&"
export * from "./platformCard.vue?vue&type=script&lang=js&"
import style0 from "./platformCard.vue?vue&type=style&index=0&id=7aecd055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aecd055",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aecd055')) {
      api.createRecord('7aecd055', component.options)
    } else {
      api.reload('7aecd055', component.options)
    }
    module.hot.accept("./platformCard.vue?vue&type=template&id=7aecd055&scoped=true&", function () {
      api.rerender('7aecd055', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/crudApp/platformCard.vue"
export default component.exports